/**
 * Contacts Service
 * Handles contact form submissions
 */

const BASE_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || '/api')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

/**
 * Submit contact form
 */
export const submitContactForm = async (contactData) => {
  try {
    const { name, email, message } = contactData;

    if (!name || !email || !message) {
      throw new Error('Name, email, and message are required');
    }

    const response = await fetch(`${BASE_URL}/contacts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to submit contact form');
    }

    return await response.json();
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

const contactServiceExports = {
  submitContactForm,
};

export default contactServiceExports;
